<template>
  <!-- 单个订单详细 -->
  <div class="contions">
    <!-- <Button>打印</Button> -->
    <div>
      <div class="one">
        <div>
          <p>Invoice To：</p>
          <p>用戶編號:{{ all.MemberID }}</p>
          <p>郵箱：{{ all.EMail }}</p>
          <p>聯系電話：{{ all.TelePhone }}</p>
          <p>訂單備注：{{ all.OrderMemo }}</p>
          <!-- <p>
            收货方式：{{(all.ServiceType == 2 ? '送货上门':(all.ServiceType == 3?'自提点自取':'未知'))}}
            收貨方式：{{order}}
        </p> -->
        </div>
        <div>
          <p>收貨人：{{ all.CName }}</p>
          <p>姓名/電話/: {{ all.CName }} {{ all.Mobile }}</p>
          <p>
            <!-- 收货方式：{{(all.ServiceType == 2 ? '送货上门':(all.ServiceType == 3?'自提点自取':'未知'))}} -->
            收貨方式：{{ order }}
          </p>
          <!-- <p>支付/收貨方式：{{all.PayType}}</p> -->
          <p>收貨地址：{{ all.Address }}</p>
        </div>
      </div>
      <!-- <div v-for="(item,index) in allorder" :key="index">{{item}}</div> -->
      <div class="two">
        <h4>Your Invoice</h4>
        <div class="date special">
          <table id="table" cellspacing="0">
            <tr>
              <td style="color:#fff">{{$t("Home.No")}}</td>
              <td style="color:#fff">{{$t("Myorder.TransshipmentOrder")}}</td>
              <td style="color:#fff">{{$t("Home.long")}}</td>
              <td style="color:#fff">{{$t("Home.wide")}}</td>
              <td style="color:#fff">{{$t("Home.height")}}</td>
              <td style="color:#fff">{{$t("Home.Weight")}}</td>
              <td style="color:#fff">{{$t("Myorder.Num")}}</td>
              <td style="color:#fff">{{$t("Home.VolumeWeight")}}</td>
              <td style="color:#fff">{{$t("Myorder.picture")}}</td>
            </tr>
            <tr v-for="(item,index) in allorder.Confim_WeightInfo" :key="index">
              <td>{{index + 1}}</td>
              <td>{{item.BillCode}}</td>
              <td>{{item.Length}}</td>
              <td>{{item.Width}}</td>
              <td>{{item.Height}}</td>
              <td>{{item.Weight}}</td>
              <td>{{item.Num}}</td>
              <td>{{item.VolumeWeight}}</td>
              <td>
                <Button type="primary" @click="showImg">
                  {{ $t('Mypackage.Packagepicture') }}
                </Button>
              </td>
            </tr>
          </table>
        </div>
        <div class="date">
          <table id="table" cellspacing="0">
            <tr>
              <td style="color:#fff">{{$t("Home.No")}}</td>
              <td style="color:#fff">{{$t("kdgs")}}</td>
              <!-- <td>集包单号</td> -->
              <td style="color:#fff">{{$t("Forecastpackage.couriernumber")}}</td>
              <td style="color:#fff">{{$t("Myorder.WarehouseNo")}}</td>
              <td style="color:#fff">{{$t("dksj")}}</td>
              <td style="color:#fff">{{$t("Forecastpackage.Namegoods")}}</td>
              <td style="color:#fff">{{$t("Mypackage.Totalweight")}}</td>
              <td style="color:#fff">{{$t("sz")}}</td>
              <td style="color:#fff">{{$t("Mypackage.AddFree")}}</td>
              <td style="color:#fff">{{$t("Myorder.picture")}}</td>
              <td style="color:#fff">{{$t("BZ")}}</td>
            </tr>
            <tr v-for="(item, index) in allorder.QueryOrderToList" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.kdCom }}</td>
              <!-- <td></td> -->
              <td>{{ item.kdBillcode }}</td>
              <td>{{ item.WaveHouse }}</td>
              <td>{{ item.ddTime }}</td>
              <td>{{ item.Goods }}</td>
              <td>{{ item.sFareWeight }}</td>
              <td>{{ item.Weight }}</td>
              <td>{{ item.AddFree }}</td>
              <td>暫無圖片</td>
              <td>{{ item.Rem }}</td>
            </tr>
            <tr>
              <td>總立方：</td>
              <td>{{ all.CubeNum.toFixed(3) }}</td>
              <td></td>
              <td>總重量：</td>
              <td>{{ all.Weight.toFixed(2) }}</td>
              <td></td>
              <td>總體積：</td>
              <td>{{ all.SumVolume}}</td>
              <td></td>
              <td>總件數：</td>
              <td>{{ all.SumCont}}</td>
            </tr>
          </table>
          <div class="three">
            <p>Totals：</p>
            <div class="block">
              <p>積分抵扣：-￥{{ all.JFFree }}</p>
              <p>集運券抵扣：-￥{{ all.Jyj_Money }}</p>
              <p>超長費：￥{{ all.longFee }}</p>
              <p>地址附加費：￥{{ all.OrterFree }}</p>
              <p>運單墊付費：￥{{ all.AddFree }}</p>
            </div>
            <div class="block">
              <p>報稅手續費：￥{{ all.Bs_Free }}</p>
              <p>總價值：￥{{ all.Bj_Money }}</p>
              <p>關稅：￥{{ all.Bj_Sxf }}</p>
              <p>代收貸款：DHS {{ all.Dshk }}</p>
              <p>貸款手續費：￥{{ all.Dshk_Sxf }}</p>
            </div>
            <div class="four">
              <div>
                <span>訂單運費：</span><span>￥{{ all.Z_Free }}</span>
              </div>
              <div>
                <span>費用總計：</span><span>￥{{ all.Fare }}</span>
              </div>
              <div>
                <span>實付費用：</span><span>￥{{ all.Fare }}（RM：{{ all.RMFree }}）</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <r-mask :title="$t('Mypackage.Packagepicture')" :isShowModal="isShowImg" @closeMask="isShowImg = false">
        <img style="width: 100%;" :src="pic_path" alt="" />
      </r-mask>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      orderID: null,
      allorder: [],
      all: {},
      order: "",
      isShowImg: false,
      pic_path: ''
    };
  },
  created() {
    this.order = this.$route.query.air_name;
  },
  mounted() {
    this.orderID = this.$route.query.orderID;
    this.QueryOrderDetail();
  },
  methods: {
    async QueryOrderDetail() {
      const params = {
        MemberID: localStorage.getItem("userID"),
        ID: this.orderID,
      };
      const { data } = await this.$post("QueryOrderDetail", params);
      if (data.State) {
        this.allorder = JSON.parse(data.ReturnJson);
        
        this.all = JSON.parse(data.ReturnJson).QueryOrderDetail[0];
        console.log(this.all);
      }
    },
    showImg() {
      if(this.all.Imgs.length) {
        this.pic_path = "http://8.134.13.247:8886/"+this.all.Imgs[0]
        this.isShowImg = true
      } else {
        this.$Message.error("該包裹暫無圖片!");
        return false;
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.contions {
  width: 1069px;
  background: #fff;
  // height: 700px;
  padding: 20px 29px;
  .one {
    display: flex;
    flex-direction: row;
    margin: 15px 0 0 0;
    div p {
      line-height: 26px;
      cursor: pointer;
    }
    > div:nth-child(2) {
      margin: 0px 0 0 100px;
    }
  }
  .two {
    margin-top: 20px;
    h4 {
      font-weight: bold;
      font-size: 20px;
    }
    .date {
      margin: 0 0 0 30px;
      #table {
        width: 100%;
        margin-top: 15px;
        cursor: pointer;
        tr {
          height: 40px;
        }
        tr:nth-child(1) {
          // background: #ccc;
          // background: linear-gradient(0deg, #ff920a 0%, #ffaf4b 100%);
          background: #4141a0;
          font-size: 14px;
          color: #fff !important;
          td {
            color: #000;
            font-size: 14px;
            font-weight: bold;
          }
        }
        td {
          width: 100px;
          font-size: 12px;
          text-align: center;
          border-bottom: 1px solid #ccc;
        }
        .td:nth-child(even) {
          background: #fff;
        }
        .td:nth-child(odd) {
          background: #f1f5fe;
        }
      }
    }
    .three {
      margin: 5px 0 0 0;
      > p {
        font-size: 16px;
        cursor: pointer;
        font-weight: bold;
      }
      .block {
        display: flex;
        flex-direction: row;
        p {
          cursor: pointer;
          margin: 0 20px;
          width: 150px;
          text-align: center;
        }
      }
    }
    .four {
      margin: 10px 0 0 0;
      div:nth-child(1) {
        background: #c3c3c3b8;
      }
      div:nth-child(2) {
        background: #c2c2c2;
      }
      div:nth-child(3) {
        // background: red;
        color: #fff;
         background: #4141a0;
      }
      div {
        width: 949px;
        height: 30px;
        background: #fff;
        span:nth-child(1) {
          float: left;
          line-height: 30px;
          padding: 0 5px;
        }
        span:nth-child(2) {
          float: right;
          line-height: 30px;
          padding: 0 5px;
        }
      }
    }
  }

  .date /deep/.ivu-table-wrapper {
    border: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/view/homeManage/Detailedorder.vue